/**
 * Client-side navigation — changes the URL and notifies the Abyss/React Router
 * without triggering a full browser reload.
 */
export function navigate(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
